<template lang="pug">
.products-grid(:class="{pen: loading}")
  template(v-if="loading")
    product-card(
      v-for="i, k in placeholders"
      :key="k")

  template(v-else)
    product-card(
      v-for="i, k in records"
      :data="i"
      :key="k"
      :type="type"
      :productCardType="productCardType"
      :trackProps="getTrackProps(k)")

</template>

<script>
import ProductCard from './ProductCard'
import { isObject, isString } from 'lodash'
import { PRODUCT_CARD_TYPES } from '~/settings'

export default {
  components: {
    ProductCard
  },

  props: {
    records: {
      type: Array,
      required: true
    },

    loading: {
      type: Boolean,
      default: false
    },

    placeholders: {
      type: Number,
      default: 12
    },

    type: {
      type: String,
      default: ''
    },

    trackProps: {
      type: [Object, String],
      default: ''
    },

    productCardType: {
      type: String,
      default: PRODUCT_CARD_TYPES.DEFAULT
    }
  },

  methods: {
    getTrackProps (index) {
      let eventProps = { position: index + 1 }

      if (isString(this.trackProps)) eventProps.zone = this.trackProps
      if (isObject(this.trackProps)) eventProps = { ...eventProps, ...this.trackProps }

      return eventProps
    }
  }
}
</script>

<style lang="scss" scoped>
.products-grid {
  display: grid;
  grid-gap: 12px 10px;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  @include media(sm) {
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  }
  @include media(lg) {
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  }
}
</style>
